module.exports = __webpack_public_path__ + "img/btn-green-en.7d8bafae.png";